import React from 'react'

function Dashboard() {
  return (
    <div className="dashboard">
      dashboard
    </div>
  )
}

export default Dashboard
